export default "__VITE_ASSET__B6iSSBFV__$_?format=webp__"